import React from 'react';
import {
	ChartComponent, SeriesCollectionDirective, SeriesDirective,
	ColumnSeries, Category, Tooltip, Legend, DataLabel, Highlight,
	Inject
} from '@syncfusion/ej2-react-charts';

const formatEuro = (value) =>
	new Intl.NumberFormat('fr-FR', {
		style: 'currency',
		currency: 'EUR',
		maximumFractionDigits: 0,
	}).format(value);

const DoubleColumnChartDommage = ({ data, title = '', id = 'double-column-chart-dommage' }) => {
	const tooltipRender = (args) => {
		const label = args.point.x;
		const value = args.point.y;

		args.text = `${label.length > 60 ? label.substring(0, 60) + '...' : label} : <b>${formatEuro(value)}</b>`;
	};

	console.log('DoubleColumnChartDommage data:', data);

	return (
		<div className="w-full">
			{title && <h2 className="mb-4 font-semibold text-lg text-center">{title}</h2>}
			<ChartComponent
				id={id}
				primaryXAxis={{
					valueType: 'Category',
					labelIntersectAction: 'Trim',
					labelRotation: -45,
					majorGridLines: { width: 0 },
					labelStyle: { size: '11px' },
				}}
				primaryYAxis={{
					labelFormat: '{value} €',
					majorTickLines: { width: 0 },
					lineStyle: { width: 0 },
					labelStyle: { size: '11px' },
					titleStyle: { size: '13px' },
				}}
				chartArea={{ border: { width: 0 } }}
				legendSettings={{
					visible: false
				}}
				tooltip={{ enable: true }}
				tooltipRender={tooltipRender}
				height="450px"
				width="100%"
			>
				<Inject services={[ColumnSeries, Legend, Tooltip, Category, DataLabel, Highlight]} />
				<SeriesCollectionDirective>
					<SeriesDirective
						dataSource={data}
						xName="x"
						yName="y"
						name="Pathologies"
						type="Column"
						fill="#3B82F6"
						cornerRadius={{ topLeft: 4, topRight: 4 }}
						marker={{ dataLabel: { visible: false } }}
					/>
				</SeriesCollectionDirective>
			</ChartComponent>
		</div>
	);
};

export default DoubleColumnChartDommage;
